import { render, staticRenderFns } from "./SkillGroupEditor.vue?vue&type=template&id=e2e28ab2"
import script from "./SkillGroupEditor.vue?vue&type=script&lang=js"
export * from "./SkillGroupEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports